
// src/redux/store/projectSlice.js

import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
  name: 'project',
  initialState: {
    project_type: '',
    id: '',
    name: '',
    steps: [],
    active_section: {
      id: '',
      name: '',
      code: '',
      description: '',
      image: '',
      steps: '',
      parent: '',
      contents:[],
      products:[],
    }
  },
  reducers: {
    setProjectData: (state, action) => {
      state.project_type = action.payload.project_type;
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.steps = action.payload.steps;
    },
    setActiveSection: (state, action) => {
      state.active_section = action.payload;
    },
    updateSection: (state, action) => {
      const payload = { ...action.payload };
      delete payload.isNestedSection;
      delete payload.initialProductIds;

      const updateSectionsRecursive = (sections = []) => {
        return sections.map((section) => {
          let updatedSection = section;

          if (section.id === payload.id) {
            console.log("charge utile de updateSection:", payload);
            updatedSection = {
              ...section,
              ...payload,
            };
          }

          if (section.nested_sections && section.nested_sections.length > 0) {
            updatedSection = {
              ...updatedSection,
              nested_sections: updateSectionsRecursive(section.nested_sections),
            };
          }

          if (section.sections && section.sections.length > 0) {
            updatedSection = {
              ...updatedSection,
              sections: updateSectionsRecursive(section.sections),
            };
          }

          return updatedSection;
        });
      };

      state.steps = state.steps.map((step) => ({
        ...step,
        sections: updateSectionsRecursive(step.sections),
      }));

      // Mettre à jour la section active si nécessaire
      if (state.active_section?.id === payload.id) {
        state.active_section = {
          ...state.active_section,
          ...payload,
        };
      }
    },
    removeFromSection: (state, action) => {
      state.sections = state.sections?.filter((product) => product.id !== action.payload.id)
    },
    reUpdateSection: (state, action) => {
      state.steps = state.steps.map((step) => {
        step.sections = step.sections.map((section) => {
          if(section.id === action.payload.id) {
            section = step.sections.filter((section) => section.id !== action.payload.id);
            console.log("charge utile de reUpdateSection:", action.payload)
          }

          return section;
        })

        return step;
      });
    },
  }
});

export const { setProjectData, setActiveSection, updateSection, removeFromSection, reUpdateSection } = projectSlice.actions;
export default projectSlice.reducer;

